// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2Nt92","row":"ProcedureTreatmentSummary_row__RkKFK"};